import { ReactNode } from 'react';

export type FormDescriptionProps = {
  enabled?: boolean;
  className?: string;
  children?: ReactNode | ReactNode[];
};

export function FormDescription({
  children,
  className,
  enabled,
}: FormDescriptionProps) {
  if (enabled === false || children == null || children === '') {
    return null;
  }
  return (
    <div className={`rje-description ${className ?? ''}`.trim()}>
      {children}
    </div>
  );
}
